/**
 * **Algolia no pagina más allá del resultado 1000** (`paginationLimitedTo`, su default, en el
 * índice main). Pasado ese punto contesta `hits: []` con `nbHits: 0`, aunque el catálogo
 * entero esté indexado: lo que tiene tope es la profundidad, no la búsqueda ni el total
 * (xcons-docs#517). Para ver lo que queda atrás se filtra, se busca, o se exporta.
 */
export const TOPE_DEL_INDICE = 1000;

/**
 * El total con el que se arma el paginador. El que se **muestra** sigue siendo el real: con
 * el real, el paginador ofrecía 891 páginas de 50 y desde la 21 llegaban vacías.
 */
export const totalPaginable = (total: number) =>
  Math.min(total, TOPE_DEL_INDICE);

/** Si hay resultados que el paginador no alcanza, que es cuando corresponde el aviso. */
export const superaElTope = (total: number) => total > TOPE_DEL_INDICE;
